const bonePain=[
    {
    label:"Site(s)",
    controlType:"checkbox group",
    options:["Head", "Neck", "Back", "Pelvis", "Right Arm", "Left Arm", "Right Leg", "Left Leg", "Hands", "Feet"]
    },

    {
    label:"Severity",
    controlType:"radio button",
    options:["Mild", "Moderate", "Severe"]   
    },

    {
    label:"When present",
    controlType:"radio button",
    options:["Constant","Intermittent"]
    },

{
    label:"Frequency",
    controlType:"radio button",
    options:["Every day", "Most days", "Occasionally"]
    },
    

    {
    label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }

]

export default bonePain



